import { render, staticRenderFns } from "./MarketSignalsPanel.vue?vue&type=template&id=52d577de&scoped=true"
import script from "./MarketSignalsPanel.vue?vue&type=script&lang=js"
export * from "./MarketSignalsPanel.vue?vue&type=script&lang=js"
import style0 from "./MarketSignalsPanel.vue?vue&type=style&index=0&id=52d577de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d577de",
  null
  
)

export default component.exports